import { isNumberControl, rankWith } from "@jsonforms/core";

export default rankWith(3, isNumberControl);
